import { OPERATIONS, ARTICLE } from './apiModules'

import { post } from '@/utils/request'

const CATEGORY = 'category'
const ARTICLE_PREFIX = `${OPERATIONS}/${ARTICLE}`
const CATEGORY_FREFIX = `${OPERATIONS}/${CATEGORY}`

export function getCategoryList(
  params = {
    type: 'ARTICLE'
  }
) {
  return post(`${CATEGORY_FREFIX}/list`, params)
}

export function addNewCategory(
  params = {
    name: '',
    parentId: '',
    type: 'ARTICLE'
  }
) {
  return post(`${CATEGORY_FREFIX}/add`, params)
}

export function updateCategory(
  params = {
    id: '',
    name: '',
    parentId: ''
  }
) {
  return post(`${CATEGORY_FREFIX}/update`, params)
}

export function deleteCategory(
  params = {
    id: ''
  }
) {
  return post(`${CATEGORY_FREFIX}/delete`, params)
}

export function getArticleList(
  params = {
    page: '',
    limit: 20,
    searchKeyword: '',
    exactMatchArr: []
  }
) {
  return post(`${ARTICLE_PREFIX}/list`, params)
}

export function addArticle(
  params = {
    url: '',
    categoryId: '',
    title: '',
    coverUrl: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/add`, params)
}
export function updateArticle(
  params = {
    id: '',
    url: '',
    categoryId: '',
    title: '',
    coverUrl: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/update`, params)
}

export function getArticleDetail(
  params = {
    id: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/detail`, params)
}

export function deleteArticle(params = { idArr: [] }) {
  return post(`${ARTICLE_PREFIX}/delete`, params)
}

export function publishArticle(
  params = {
    idArr: [],
    publish: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/publish`, params)
}

export function topArticle(
  params = {
    idArr: [],
    top: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/top`, params)
}

export function hotArticle(
  params = {
    idArr: [],
    hot: ''
  }
) {
  return post(`${ARTICLE_PREFIX}/hot`, params)
}
